import axiosPrivate from "@services/axiosPrivate"

export const reportConcernSupport = async (data) => {
    const response = await axiosPrivate.post(`vision/report-support`, data)
    return response
}